var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import config from '@/config';
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { findTaskById, updateTask } from '@/shared/utils/infiniteDataHelper';
import { TaskQueryKey } from './queryKey';
var updateTaskDeadline = function (oldData, newData) {
    if (!newData)
        return oldData;
    var newValue = __assign(__assign({}, oldData), { deadline: newData.deadline });
    var mainTask = newValue;
    var newMainTask = newData;
    if (!(mainTask === null || mainTask === void 0 ? void 0 : mainTask.children))
        return newValue;
    if (!(newMainTask === null || newMainTask === void 0 ? void 0 : newMainTask.children))
        return newValue;
    mainTask.children = mainTask.children.map(function (c) {
        var newChild = newMainTask.children.find(function (y) { return y.id === c.id; });
        if (!newChild)
            return c;
        return __assign(__assign({}, c), { deadline: newChild.deadline });
    });
    return mainTask;
};
export var useUpdateTaskDeadline = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (values) {
        var _a;
        return api.base
            .put("".concat(config.appUrls.tasks, "/api/plannedTasks/deadline/").concat(values.id, "/").concat((_a = values.deadline) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD')), null, {
            params: {
                taskLevel: values.taskLevel,
            },
        })
            .then(function (res) { return res.data; });
    }, {
        onMutate: function (taskToUpdate) { return __awaiter(void 0, void 0, void 0, function () {
            var currentData, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Cancel any outgoing refetches
                    // (so they don't overwrite our optimistic update)
                    return [4 /*yield*/, queryClient.cancelQueries({ queryKey: [TaskQueryKey.PlannedTasks] })];
                    case 1:
                        // Cancel any outgoing refetches
                        // (so they don't overwrite our optimistic update)
                        _a.sent();
                        currentData = queryClient.getQueryData([TaskQueryKey.PlannedTasks]);
                        result = findTaskById(currentData, taskToUpdate.id);
                        if (result) {
                            queryClient.setQueryData([TaskQueryKey.PlannedTasks], function (oldData) {
                                return updateTask(oldData, taskToUpdate.id, function (x) { return (__assign(__assign({}, x), { deadline: taskToUpdate.deadline })); });
                            });
                        }
                        return [2 /*return*/, { previousTask: result === null || result === void 0 ? void 0 : result.task }];
                }
            });
        }); },
        onSuccess: function (data) {
            queryClient.setQueryData([TaskQueryKey.PlannedTasks], function (oldData) {
                return updateTask(oldData, data.id, function (x) { return updateTaskDeadline(x, data); });
            });
        },
        onError: function (e, taskToUpdate, context) {
            queryClient.setQueryData([TaskQueryKey.PlannedTasks], function (oldData) {
                return updateTask(oldData, taskToUpdate.id, function (x) { return updateTaskDeadline(x, context === null || context === void 0 ? void 0 : context.previousTask); });
            });
            handleHttpError(intl)(e);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading, error = _a.error;
    return {
        updateTaskDeadline: mutateAsync,
        isLoading: isLoading,
        error: error,
    };
};
